export const zoomSettingsDefaultValues = {
  integrationType: 'recording',
  removeSessionWhenNoRecording: true,
}

export type ZoomSettingsFormValues = {
  integrationType: 'recording' | 'bot'
  removeSessionWhenNoRecording: boolean
  autoJoin: boolean | undefined
}
